import { useEffect, useState } from 'react';
import avo from 'analytics/avo';
import useDebouncedValue from 'hooks/useDebouncedValue';
import { getFiltersInAvoFormat, getSortInAvoFormat } from '../utils';
const useProductListingAnalytics = pageData => {
  const {
    pageId,
    pageName,
    filters = [],
    sortOrder = [],
    products = [],
    loading,
    filterStateKey
  } = pageData;
  const [listViewed, setListViewed] = useState(false);
  const [, setLastTrackedFilterState] = useState('no-filters--featured');
  const debouncedFilterStateKey = useDebouncedValue(filterStateKey, 500);
  useEffect(() => {
    if (!loading && !listViewed) {
      setListViewed(true);
      try {
        if (!Number.isNaN(pageId)) {
          avo.productListViewed({
            categoryId: pageId,
            listId: pageName,
            category: pageName,
            filters: getFiltersInAvoFormat(filters) || [''],
            products: products.map(product => {
              const {
                variantsToShow = []
              } = product;
              const firstVariantShown = variantsToShow?.[0];
              return {
                category: pageName,
                name: product.name,
                shippingCarrier: 'Custom',
                shippingMethod: 'Curbside',
                currency: 'USD',
                price: parseFloat(firstVariantShown.price),
                fullPrice: parseFloat(firstVariantShown.originalPrice),
                productId: product.id,
                quantity: 1,
                sku: firstVariantShown.sku,
                isFlashSale: !!firstVariantShown.isFlashSale,
                googleProductCategory: product?.googleProductCategory || ''
              };
            })
          });
        }
      } catch {
        // Ignore error if avo is not initialized
      }
    }
  }, [filters, listViewed, loading, pageId, pageName, products]);
  useEffect(() => {
    if (!pageName || debouncedFilterStateKey === null) {
      return;
    }
    setLastTrackedFilterState(prevLastTrackedFilterState => {
      if (debouncedFilterStateKey === prevLastTrackedFilterState) {
        return prevLastTrackedFilterState;
      }
      try {
        avo.productListFiltered({
          categoryId: pageId,
          listId: pageName,
          category: pageName,
          filters: getFiltersInAvoFormat(filters) || [''],
          sorts: getSortInAvoFormat(sortOrder) || [''],
          products: products.map(product_0 => {
            const {
              variantsToShow: variantsToShow_0 = []
            } = product_0;
            const firstVariantShown_0 = variantsToShow_0?.[0];
            return {
              category: pageName,
              name: product_0.name,
              currency: 'USD',
              price: parseFloat(firstVariantShown_0.price),
              fullPrice: parseFloat(firstVariantShown_0.originalPrice),
              productId: product_0.id,
              quantity: 1,
              sku: firstVariantShown_0.sku,
              isFlashSale: !!firstVariantShown_0?.isFlashSale,
              googleProductCategory: product_0?.googleProductCategory || ''
            };
          })
        });
      } catch {
        // Ignore error if avo is not initialized
      }
      return filterStateKey;
    });
  }, [pageName, filters, products, loading, pageId, sortOrder, debouncedFilterStateKey, filterStateKey]);
};
export default useProductListingAnalytics;